import { ReactNode } from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Skeleton from '@material-ui/lab/Skeleton';
import clsx from 'clsx';
import Detail from "./Detail";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useI18n } from '../hooks/i18n-hooks';


interface DetailSectionProps {
	keys: string[];
	i18nObject: any;
	info?: any;
	checks?: boolean;
	children?: ReactNode;
	ltr?: boolean;
}

const DetailSection: React.FC<DetailSectionProps> = ({ info, keys, checks, i18nObject, children, ltr = false }) => {

	const classes = useStyles();
	const isMobile = useMediaQuery('(max-width: 800px)');
	const contactTextMobile = useI18n(i => i.am.contactPersonShort);


	return (
		<div className='section'>
			{!!info ? keys.map(key => <div key={key} className={clsx('detail-row', checks && 'checks', ltr && classes.ltr)}>
				<div>{isMobile && key === 'contact' ? contactTextMobile : i18nObject[key]}</div>
				<Detail
					info={info}
					id={key}
					checks={checks}
					children={children}
				/>
			</div>)
				: keys.map(key => <div key={key} className={clsx('skeleton-row', classes.skeletonRow)}>
					<Skeleton variant="text" width={Math.random() * 32 + 22 + '%'} />
					<Skeleton variant="text" width={Math.random() * 32 + 22 + '%'} />
				</div>
				)
			}
		</div >
	);
}

export default DetailSection;

const useStyles = makeStyles({
	ltr: {
		direction: 'ltr',
		'&>div': {
			textAlign: 'initial'
		}
	},
	skeletonRow: {
		width: '32vw'
	}
})